<template>
  <section class="assessmentSection questionsSection">
    <div class="questionsTopBG" />
    <div class="pageContent">
      <div class="pageTitle">We need to know about any pets you have.</div>

      <question id="21" lead-key="hasPets" type="multiple" ref="hasPets" />

      <transition name="fade">
        <div v-if="hasPets">
          <transition name="fade">
            <div v-if="lead.hasPets">
              <question id="14" lead-key="petsFreeRoam" ref="petsFreeRoam" />
            </div>
          </transition>

          <!-- ADVICE -->
          <transition name="fade">
            <inline-advice v-if="dogsHaveFreeRoam">
              <div slot="title">When you’re gone, your dog can trip armed motion sensors</div>
              <div slot="text">
                We’re pet lovers too, but pets with free roam can cause problems for your motion sensor.
                <br />
                <br />To avoid unwanted alarms, a
                <router-link to="/assessment/help/what-are-pet-alleys">pet alley</router-link>will be installed. Allowing the dog space underneath the motion sensors vision.
              </div>
            </inline-advice>
          </transition>

          <!-- Advice -->
          <transition name="fade">
            <inline-advice v-if="catsHaveFreeRoam && lead.protectionLevel !== 'Total'">
              <div slot="title">Cat’s love to jump around</div>
              <div slot="text">
                <p>We’re pet lovers too, but pets with free roam can cause problems for your motion sensor. Here are some things to consider.</p>
                <p>
                  Cats like to jump and climb, which can trigger motion sensors. We recommend
                  <router-link to="/assessment/protection-level">Total Level Protection</router-link>.
                </p>
              </div>
            </inline-advice>
          </transition>

          <transition name="fade">
            <div v-if="dogsHaveFreeRoam">
              <question id="22" lead-key="dogsOver80" ref="dogsOver80" />
            </div>
          </transition>

          <transition name="fade">
            <inline-advice v-if="dogsHeavyAndRoam && lead.protectionLevel !== 'Total'">
              <div slot="title">Larger dogs can trip armed motion sensors</div>
              <div slot="text">
                A
                <router-link to="/assessment/help/what-are-pet-alleys">pet alley</router-link>works by creating a zone under the motion sensors “field of vision” allowing a dog to move freely underneath. But dogs over 80 lbs can start to creep into that zone, causing unwanted alarms.
                <br />
                <br />Total level protection allows you to not have to rely on motion sensors by protecting all accessible windows. We recommend switching to
                <router-link to="/assessment/protection-level">Total Level Protection</router-link>.
              </div>
            </inline-advice>
          </transition>
        </div>
      </transition>

      <continue-button :before="mixpanelTracking" to="/assessment/automation" />
      <div class="startOverSection text-center">
        <a
          href="/assessment/start-over"
          onclick="mixpanel.track('startedOver')"
        >Clear data and start over</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["lead"]),

    hasDogs() {
      return this.lead.hasPets.includes("Dogs");
    },

    hasCats() {
      return this.lead.hasPets.includes("Cats");
    },

    hasPets() {
      return this.hasDogs || this.hasCats;
    },

    dogsHaveFreeRoam() {
      let hasDogs = this.hasDogs;
      let hasFreeRoam = this.lead.petsFreeRoam == "Yes";
      return hasDogs && hasFreeRoam;
    },

    catsHaveFreeRoam() {
      let hasCats = this.hasCats;
      let hasFreeRoam = this.lead.petsFreeRoam == "Yes";
      return hasCats && hasFreeRoam;
    },

    dogsHeavyAndRoam() {
      let roam = this.dogsHaveFreeRoam;
      let heavy = this.lead.dogsOver80 == "Yes";
      return roam && heavy;
    }
  },

  methods: {
    mixpanelTracking() {
      let data = {
        A_Pet_type: this.lead.hasPets,
        A_Pet_hasFreeRoam: this.lead.petsFreeRoam == "Yes",
        A_Pet_dogWeight: this.lead.dogsOver80 == "Yes"
      };
      mixpanel.track("completedPetsSection", data);
      mixpanel.people.set(data);
    }
  },

  mounted() {
    this.$Progress.set(49);
  }
};
</script>

<style lang="css">
</style>
